module.exports = __webpack_public_path__ + "assets/img/test-icon.0b6f0d9a.png";